import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const PrivateRoute = ({ children, requiredRole }) => {
  const token = localStorage.getItem('authToken');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000;
    if (decoded.exp && decoded.exp < now) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole');
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    
    const roleClaimType = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
    const rawRole = decoded.role || decoded[roleClaimType] || localStorage.getItem('userRole');

    const userRoles = Array.isArray(rawRole) ? rawRole : (rawRole ? [rawRole] : []);


    if (requiredRole) {
      const hasExactRole = userRoles.includes(requiredRole);

      const isSuperAdminAccessingAdmin = requiredRole === 'ADMIN' && userRoles.includes('SUPERADMIN');

      if (!hasExactRole && !isSuperAdminAccessingAdmin) {

        if (userRoles.includes('SUPERADMIN')) {
             if (location.pathname.startsWith('/super-admin')) {
                 return <Navigate to="/dashboard" replace />;
             }
             return <Navigate to="/super-admin/dashboard" replace />;
        }
        return <Navigate to="/dashboard" replace />;
      }
    }

    return children;
  } catch (error) {
    console.error('Invalid token:', error);
    localStorage.removeItem('authToken');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
};

export default PrivateRoute;